<template>
  <el-dialog
    class="modify-notice_dialog"
    :visible.sync="visible"
    :close-on-click-modal="false"
    title="修改通知"
    @open="openDialog"
    @close="closeDialog"
    @closed="resetDialog"
  >
    <el-form
      ref="modifyForm"
      label-width="80px"
      :model="modifyForm"
      :rules="rules"
    >
      <el-form-item
        label="接收人"
        class="surveyors-item"
      >
        <el-tag
          v-for="item in surveyors"
          :key="item.id"
          effect="plain"
          size="small"
          class="surveyor-tag"
        >{{item.name}}</el-tag>
      </el-form-item>
      <el-form-item
        label="通知标题"
        prop="title"
      >
        <el-input
          v-model.trim="modifyForm.title"
          placeholder="请输入通知标题"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="通知内容"
        prop="content"
      >
        <el-input
          v-model.trim="modifyForm.content"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 10}"
          resize="none"
          placeholder="请输入通知内容"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleCancel">{{isModify?'重置':'取消'}}</el-button>
        <el-button
          type="primary"
          :loading="loading"
          :disabled="!isModify"
          @click="modifyNotice"
        >修改</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { modifyNotice } from "@/api/notice";
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      //弹窗的显示或隐藏
      visible: false,
      //修改按钮的loading状态
      loading: false,
      //修改的表单数据
      modifyForm: {
        title: "",
        content: ""
      },
      //需要修改的通知的原始数据
      rawData: {},
      //通知的接收人列表
      surveyors: [],
      //修改的表单验证规则
      rules: {
        title: [
          {
            required: true,
            message: "请输入通知标题",
            trigger: "blur"
          }
        ],
        content: [
          {
            required: true,
            message: "请输入通知内容",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    //判断是否修改
    isModify() {
      return JSON.stringify(this.modifyForm) !== JSON.stringify(this.rawData);
    }
  },
  watch: {
    show() {
      this.visible = this.show;
    }
  },
  methods: {
    //修改通知
    async modifyNotice() {
      let valid = await this.validate();
      if (!valid) return;
      this.loading = true;
      modifyNotice(this.data.id, this.modifyForm)
        .then(() => {
          this.$emit("success");
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "通知修改失败",
            duration: 1500,
            center: true
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //处理取消按钮的事件
    handleCancel() {
      //如果修改了则重置表单
      if (this.isModify) {
        this.$refs.modifyForm.clearValidate();
        this.modifyForm = {
          ...this.rawData
        };
      } else {
        //否则就关闭弹窗
        this.closeDialog();
      }
    },
    //打开弹窗
    openDialog() {
      this.modifyForm = {
        title: this.data.title,
        content: this.data.content
      };
      this.rawData = {
        title: this.data.title,
        content: this.data.content
      };
      this.surveyors = this.data.surveyors;
    },
    //关闭弹窗
    closeDialog() {
      this.$emit("update:show", false);
    },
    //重置弹窗的数据
    resetDialog() {
      this.modifyForm = {};
      this.rawData = {};
      this.surveyors = [];
    },
    //表单验证
    validate() {
      return new Promise(resolve => {
        this.$refs.modifyForm.validate(valid => {
          resolve(valid);
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.surveyors-item {
  margin-bottom: 15px;
}
.surveyor-tag + .surveyor-tag {
  margin-left: 10px;
}
</style>